import { MeetingLinkProvider as ApiMeetingLinkProvider } from '@wix/ambassador-ai-scheduling-assistant-v1-meeting-type/types';
import { MeetingLinkProvider } from '../../commonTypes/MeetingLinkProvider';
export function convertMeetingTypesFilter(filter) {
  return {
    ...(filter.name != null && {
      tokenId: filter.name
    }),
    ...(filter.calendarTokenId != null && {
      tokenId: filter.calendarTokenId
    }),
    ...(filter.defaultService != null && {
      default: filter.defaultService
    }),
    ...(filter.meetingLinkProvider != null && {
      meetingLinkProvider: convertMeetingLinkProviderToApi(filter.meetingLinkProvider)
    })
  };
}
export function convertApiToMeetingLinkProvider(apiProvider) {
  if (!apiProvider) {
    return MeetingLinkProvider.NO_MEETING_LINK;
  }
  switch (apiProvider) {
    case ApiMeetingLinkProvider.GOOGLE:
      return MeetingLinkProvider.GOOGLE;
    case ApiMeetingLinkProvider.MICROSOFT:
      return MeetingLinkProvider.MICROSOFT;
    case ApiMeetingLinkProvider.NO_MEETING_LINK:
    default:
      return MeetingLinkProvider.NO_MEETING_LINK;
  }
}
export function convertMeetingLinkProviderToApi(meetingLinkProvider) {
  if (!meetingLinkProvider) {
    return ApiMeetingLinkProvider.NO_MEETING_LINK;
  }
  switch (meetingLinkProvider) {
    case MeetingLinkProvider.GOOGLE:
      return ApiMeetingLinkProvider.GOOGLE;
    case MeetingLinkProvider.MICROSOFT:
      return ApiMeetingLinkProvider.MICROSOFT;
    case MeetingLinkProvider.NO_MEETING_LINK:
    default:
      return ApiMeetingLinkProvider.NO_MEETING_LINK;
  }
}
//# sourceMappingURL=converters.js.map